import React from 'react'
import styled from 'styled-components'
import { SpaceResponsive, Title } from '../../Pages/NewApp/NewAppBannerPage'

// 그룹채팅 큐레이션 섹션 미리보기 (collectionName 'group collage').
// 카드 한 장 = 캐릭터 묶음. 앱의 콜라주 카드처럼 멤버 프로필을 2/3/4 분할로 겹쳐 보여 준다.
//   - 라이브 버전 : Stipop API v2 응답의 groupList (카드.collection = 멤버)
//   - 작업 버전   : 어드민 API 응답의 collection (같은 모양)
// 다른 layout('group deck' 등)이 추가되면 layout 값으로 분기하되, 모르는 값은 이 콜라주로 그린다.
const DEFAULT_PROFILE =
  'https://img.stipop.io/image/stipop/icon/chat/chat-create-profile-icon.png'

const memberName = (member, lang) => {
  if (member.assistantInfo && Array.isArray(member.assistantInfo)) {
    const localized = member.assistantInfo.filter(a => a.lang === lang)[0]
    if (localized && localized.assistantName) return localized.assistantName
  }
  return member.assistantName || ''
}

const GroupCollageCard = props => {
  const { title, cards, lang } = props
  const list = Array.isArray(cards) ? cards : []

  return (
    <>
      <Title>{title}</Title>
      <SpaceResponsive height={16} />
      <Wrapper>
        <CardRow>
          {list.map((card, index) => {
            const members = (card.collection || []).filter(m => m.assistantId)
            const shown = members.slice(0, 4)
            return (
              <Card key={card.groupId || card.seq || index}>
                <Collage count={shown.length}>
                  {shown.map((m, i) => (
                    <img key={i} src={m.profileImg || DEFAULT_PROFILE} alt="" />
                  ))}
                  {members.length > 4 && <More>+{members.length - 4}</More>}
                </Collage>
                <CardTitle>{card.title || ''}</CardTitle>
                <CardMembers>
                  {members.map(m => memberName(m, lang)).filter(Boolean).join(' · ')}
                </CardMembers>
                {card.description ? <CardDesc>{card.description}</CardDesc> : null}
                <Cta>그룹채팅 시작</Cta>
              </Card>
            )
          })}
        </CardRow>
      </Wrapper>
      <SpaceResponsive height={34} />
    </>
  )
}

export default GroupCollageCard

const Wrapper = styled.div`
  width: 100%;
  overflow-x: scroll;
  position: relative;
`

const CardRow = styled.div`
  display: flex;
  column-gap: 10px;
`

const Card = styled.div`
  min-width: 236px;
  width: 236px;
  display: flex;
  flex-direction: column;
  row-gap: 6px;
  border: 1px solid #e5e5e5;
  border-radius: 16px;
  padding: 10px;
  box-sizing: border-box;
  background-color: #fff;
`

// 2명: 좌우 / 3명: 좌 1 + 우 2 / 4명: 2x2
const Collage = styled.div`
  width: 100%;
  height: 140px;
  display: grid;
  gap: 3px;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  grid-template-columns: ${props => (props.count <= 1 ? '1fr' : '1fr 1fr')};
  grid-template-rows: ${props => (props.count >= 3 ? '1fr 1fr' : '1fr')};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background-color: #eee;
  }

  img:first-child {
    grid-row: ${props => (props.count === 3 ? '1 / span 2' : 'auto')};
  }
`

const More = styled.div`
  position: absolute;
  right: 6px;
  bottom: 6px;
  padding: 2px 6px;
  border-radius: 10px;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 11px;
  font-family: Poppins;
`

const CardTitle = styled.div`
  font-size: 13px;
  font-family: Poppins;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CardMembers = styled.div`
  font-size: 11px;
  font-family: Poppins;
  color: #787878;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const CardDesc = styled.div`
  font-size: 10px;
  font-family: Poppins;
  color: #999;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const Cta = styled.div`
  margin-top: 2px;
  height: 28px;
  border-radius: 14px;
  background-color: #111;
  color: #fff;
  font-size: 11px;
  font-family: Poppins;
  display: flex;
  align-items: center;
  justify-content: center;
`
